export default "__VITE_ASSET__9c5802a9__"